'use strict'

export const password = (() => {
    const init = () => {
        const togglePasswords = document.querySelectorAll('.toggle-password')
        const passwordInputs = document.querySelectorAll('input[type="password"]')

        if (togglePasswords.length && passwordInputs.length) {
            const togglePasswordInputs = () => {
                passwordInputs.forEach((passwordInput) => {
                    passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
                })
            }

            togglePasswords.forEach((togglePassword) => {
                togglePassword.addEventListener('click', () => togglePasswordInputs())
            })
        }
    }

    return {
        init
    }
})()
